import {
  FETCH_QUICK_STATS,
  FETCH_QUICK_STATS_SUCCESS,
  FETCH_QUICK_STATS_FAILURE,
  FETCH_PENDING_ORDERS,
  FETCH_PENDING_ORDERS_SUCCESS,
  FETCH_PENDING_ORDERS_FAILURE,
  SET_FILTER_MERCHANT_VALUE,
  SET_FILTER_STORE_VALUE
} from "../constants/dashboardActionsType";

const initialState = {
  stats: {
    total: 0,
    week: 0,
    pending_orders: 0,
    fulfilled_orders: 0
  },
  statsActions: {
    isLoading: false,
    error: ""
  },
  ordersActions: {
    isLoading: false,
    error: ""
  },
  pendingOrders: {},
  filterValues: {
    merchant: {},
    store: {}
  }
};

export const dashboardReducer = (
  state = initialState,
  { data, error, type }
) => {
  switch (type) {
    case FETCH_QUICK_STATS:
      return {
        ...state,
        statsActions: {
          isLoading: true
        }
      };

    case FETCH_QUICK_STATS_SUCCESS:
      return {
        ...state,
        statsActions: {
          isLoading: false
        },
        stats: data
      };

    case FETCH_QUICK_STATS_FAILURE:
      return {
        ...state,
        stats: initialState.stats,
        statsActions: {
          isLoading: false,
          error
        }
      };
    case FETCH_PENDING_ORDERS:
      return {
        ...state,
        ordersActions: {
          error: "",
          isLoading: true
        }
      };

    case FETCH_PENDING_ORDERS_SUCCESS:
      return {
        ...state,
        pendingOrders: data,
        ordersActions: {
          ...state.ordersActions,
          isLoading: false
        }
      };

    case FETCH_PENDING_ORDERS_FAILURE:
      return {
        ...state,
        ordersActions: {
          ...state.ordersActions,
          error,
          isLoading: false
        }
      };
    case SET_FILTER_MERCHANT_VALUE:
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          merchant: data,
          store: {}
        }
      };

    case SET_FILTER_STORE_VALUE:
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          store: data
        }
      };
    default:
      return state;
  }
};
